import confetti, { Options } from "canvas-confetti";

export default class Confetti {
    static confettiSettings: { count: number; defaults: Options };

    constructor(count: number, defaults: Options) {
        Confetti.confettiSettings = {
            count: count,
            defaults: {
                ...defaults
            }
        };
    }

    public async render() {
        const confetti = document.createElement("div");
        confetti.classList.add("confetti");
        document.body.appendChild(confetti);

        this.fireConfetti(0.25, {
            spread: 26,
            startVelocity: 55
        });
        this.fireConfetti(0.2, {
            spread: 60
        });
        this.fireConfetti(0.35, {
            spread: 100,
            decay: 0.91,
            scalar: 0.8
        });
        this.fireConfetti(0.1, {
            spread: 120,
            startVelocity: 25,
            decay: 0.92,
            scalar: 1.2
        });
        // According to the docs of `confetti` calling it multiple times
        // uses the same canvas and stacks animation. The returned promise is resolved once
        // all stacked animation-promises resolved.
        await this.fireConfetti(0.1, {
            spread: 120,
            startVelocity: 45
        });
    }

    private fireConfetti(particleRatio: number, opts: any): Promise<void> {
        const defaults = Confetti.confettiSettings.defaults;
        const count = Confetti.confettiSettings.count as number;
        return confetti(
            Object.assign({}, defaults, opts, {
                particleCount: Math.floor(count * particleRatio)
            })
        );
    }
}
